/* BETALUMINA_INTERVENTO_DRAFT_STORAGE_V1_R3 */

export const INTERVENTO_DRAFT_PREFIX = "betalumina:intervento-draft:v1:";
export const INTERVENTO_DRAFT_MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000;

function cleanPart(value) {
  return String(value ?? "")
    .trim()
    .replace(/[^a-zA-Z0-9_.-]+/g, "_")
    .slice(0, 120);
}

export function getInterventoDraftKey({ interventoId, numeroFoglioIntervento } = {}) {
  const id = Number(interventoId);
  if (Number.isInteger(id) && id > 0) return `${INTERVENTO_DRAFT_PREFIX}id:${id}`;

  const foglio = cleanPart(numeroFoglioIntervento);
  if (foglio) return `${INTERVENTO_DRAFT_PREFIX}fi:${foglio}`;

  return `${INTERVENTO_DRAFT_PREFIX}new`;
}

export function getInterventoDraftAliasKeys(identity = {}) {
  const keys = new Set([getInterventoDraftKey(identity)]);
  const id = Number(identity.interventoId);

  if (Number.isInteger(id) && id > 0) {
    keys.add(`${INTERVENTO_DRAFT_PREFIX}id:${id}`);
  }

  const foglio = cleanPart(identity.numeroFoglioIntervento);
  if (foglio) keys.add(`${INTERVENTO_DRAFT_PREFIX}fi:${foglio}`);

  keys.add(`${INTERVENTO_DRAFT_PREFIX}new`);
  return [...keys];
}

function safeStorage() {
  if (typeof window === "undefined") return null;
  try { return window.localStorage; } catch (_) { return null; }
}

export function readInterventoDraft(key) {
  const storage = safeStorage();
  if (!storage || !key) return null;

  try {
    const raw = storage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (
      !parsed ||
      parsed.schema !== 1 ||
      !Number.isFinite(Number(parsed.savedAt)) ||
      !parsed.data ||
      typeof parsed.data !== "object"
    ) {
      storage.removeItem(key);
      return null;
    }

    return parsed;
  } catch (_) {
    return null;
  }
}

export function writeInterventoDraft(key, data) {
  const storage = safeStorage();
  if (!storage || !key || !data) return false;

  try {
    storage.setItem(
      key,
      JSON.stringify({ schema: 1, savedAt: Date.now(), data })
    );
    return true;
  } catch (_) {
    return false;
  }
}

export function removeInterventoDraft(key) {
  const storage = safeStorage();
  if (!storage || !key) return;
  try { storage.removeItem(key); } catch (_) {}
}

export function clearInterventoDraftAliases(identity = {}) {
  for (const key of getInterventoDraftAliasKeys(identity)) {
    removeInterventoDraft(key);
  }
}

export function pruneExpiredInterventoDrafts(
  now = Date.now(),
  maxAgeMs = INTERVENTO_DRAFT_MAX_AGE_MS
) {
  const storage = safeStorage();
  if (!storage) return 0;

  let removed = 0;

  try {
    for (let index = storage.length - 1; index >= 0; index -= 1) {
      const key = storage.key(index);
      if (!key || !key.startsWith(INTERVENTO_DRAFT_PREFIX)) continue;

      const draft = readInterventoDraft(key);

      if (!draft || now - Number(draft.savedAt) > maxAgeMs) {
        storage.removeItem(key);
        removed += 1;
      }
    }
  } catch (_) {}

  return removed;
}
